const getters = {
  globalLoading: (state) => state.globalLoading,
  globalLoadingMessageArray: (state) => state.globalLoadingMessageArray,
  snackbar: (state) => state.snackbar,
  snackbarType: (state) => state.snackbarType,
  snackbarText: (state) => state.snackbarText,
  confirmationDialog: (state) => state.confirmationDialog,
  confirmationDialogConfig: (state) => state.confirmationDialogConfig,
  confirmarDialog: (state) => state.confirmarDialog,
  confirmarDialogConfig: (state) => state.confirmarDialogConfig,
  confirmarDialogPromiseResolve: (state) => state.confirmarDialogPromiseResolve,
  confirmarDialogPromiseReject: (state) => state.confirmarDialogPromiseReject,
  informacao: (state) => state.informacao
}

export default getters



// WEBPACK FOOTER //
// ./src/vuex/ui/getters.js